import FormLabel from '@mui/material/FormLabel';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const CustomFormLabel = ({ label, tooltip, ...props }) => {
  return (
    <FormLabel {...props}>
      {label}
      {tooltip && (
        <Tooltip title={tooltip}>
          <InfoOutlinedIcon
            color="primary"
            fontSize="small"
            sx={{ ml: 0.5, verticalAlign: 'middle', mt: '-1px' }}
          />
        </Tooltip>
      )}
    </FormLabel>
  );
};

export default CustomFormLabel;
